import instance from "../utils/network";

export enum TierType {
  MASTER = "MASTER",
  DIAMOND = "DIAMOND",
  GOLD = "GOLD",
  SILVER = "SILVER",
  BRONZE = "BRONZE",
}

export interface NowSeasonRes {
  createdAt: string;
  updatedAt: string;
  id: number;
  seasonNumber: number;
  seasonName: string;
  startDate: string;
  endDate: string;
}

export interface SellerRankingDto {
  rank: number;
  userId: number;
  nickname: string;
  score: number;
  tier: TierType;
  item: string;
}

export interface SellerRankingResponse {
  item1: SellerRankingDto[];
  item2: SellerRankingDto[];
  item3: SellerRankingDto[];
}

export function getRunnerRanking(
  pubId: number,
  item1: string,
  item2: string,
  item3: string
): Promise<SellerRankingResponse> {
  return instance.get(
    `/seller/member-ranking/ranking?pubId=${pubId}&item1=${item1}&item2=${item2}&item3=${item3}`
  );
}

export function getNowPubSeason(): Promise<NowSeasonRes> {
  return instance.get(`/ranking-season/pub`);
}
